<template>
  <div>
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/cfmchurch_bg_011.jpg);"
      ></div>
      <div class="container">
        <h1>Live <span>Event</span></h1>
        <ul>
          <li><router-link to="/" :exact="true">Home</router-link></li>
          <li><router-link to="/watch-live">Watch Live</router-link></li>
        </ul>
      </div>
    </div>
    <live-event></live-event>
    <footer-cov></footer-cov>
  </div>
</template>
<script>
export default {
  components: {
    LiveEvent: () => import("../components/LiveEvent"),
    FooterCov: () => import("../components/FooterCoventry"),
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
  /* mounted: function() {

  }, */
};
</script>
